import { css } from 'styled-components';

import CalibreLightWoff2 from '@fonts/Calibre/Calibre-Light.woff2';
import CalibreLightItalicWoff2 from '@fonts/Calibre/Calibre-LightItalic.woff2';
import CalibreRegularWoff2 from '@fonts/Calibre/Calibre-Regular.woff2';
import CalibreRegularItalicWoff2 from '@fonts/Calibre/Calibre-RegularItalic.woff2';
import CalibreMediumWoff2 from '@fonts/Calibre/Calibre-Medium.woff2';
import CalibreMediumItalicWoff2 from '@fonts/Calibre/Calibre-MediumItalic.woff2';
import CalibreSemiboldWoff2 from '@fonts/Calibre/Calibre-Semibold.woff2';
import CalibreSemiboldItalicWoff2 from '@fonts/Calibre/Calibre-SemiboldItalic.woff2';

// woff2 only — it covers this project's browserslist ("> 0.25%, not dead"),
// so the .woff and .ttf duplicates were dropped.
const calibre = [
  [300, 'normal', CalibreLightWoff2],
  [300, 'italic', CalibreLightItalicWoff2],
  [400, 'normal', CalibreRegularWoff2],
  [400, 'italic', CalibreRegularItalicWoff2],
  [500, 'normal', CalibreMediumWoff2],
  [500, 'italic', CalibreMediumItalicWoff2],
  [600, 'normal', CalibreSemiboldWoff2],
  [600, 'italic', CalibreSemiboldItalicWoff2],
];

const calibreFaces = calibre
  .map(
    ([weight, style, src]) => `
      @font-face {
        font-family: 'Calibre';
        src: url(${src}) format('woff2');
        font-weight: ${weight};
        font-style: ${style};
        font-display: swap;
      }
    `,
  )
  .join('');

const Fonts = css`
  ${calibreFaces}
`;

export default Fonts;
